<template>
    <v-list nav dense>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/invitacion_tab">
            <v-list-tile-action>
                <v-icon medium>event</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Invitaciones')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/records_no_code">
            <v-list-tile-action>
                <v-icon medium>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Historial')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/companiesByPark">
            <v-list-tile-action>
                <v-icon medium>business</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Empresas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
                <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                :to="parkContractsRoute">
            <v-list-tile-action>
                <v-icon medium>security</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>{{$t('security_pending_park_contracts')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/caseta_parque">
            <v-list-tile-action>
                <v-icon medium>local_convenience_store</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Casetas')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/vigilante_parque">
            <v-list-tile-action>
                <v-icon medium>assignment_ind</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('Vigilantes')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon medium>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile ><h3>{{$t('configuracion')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon medium>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile><h3>{{$t('Ayuda')}}</h3></v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "admin_parque",
        computed: {
            ...mapGetters(['getProfile']),
            parkContractsRoute() {
                const parkId = this.getProfile && (
                    this.getProfile.id_park ||
                    this.getProfile.park_id ||
                    this.getProfile.park ||
                    this.getProfile.id_parque
                )
                return parkId
                    ? { name: 'security_pending_park_contracts', params: { parkId } }
                    : '/security/pending-park-contracts'
            }
        },
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    .tile {
        margin: 5px;
        border-radius: 4px;
    }
</style>
